import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { useSelector, useDispatch } from 'react-redux';
import { List, Empty, message, Skeleton, Form, Input, Rate, Select, Tag } from 'antd';
import { useCookies } from 'react-cookie';
import { setLocation } from '../../../../redux/locations/reducer';
import { setSearch_spec_form } from '../../../../redux/specialist/reducer';
import { getMp_info_home } from '../../../../API/mp_info';
import { API, UPLOADS } from '../../../../params';
import { 
    getSpecialistList, getSpecialistSpecializationList
} from '../../../../API/specialist';
import {
    SearchOutlined
} from '@ant-design/icons';
import { MdOutlineNoPhotography } from "react-icons/md";

export const City_1321_02 = props => {
    const dispatch = useDispatch();

    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const locations = useSelector(state => state.locations);
    const specialist = useSelector(state => state.specialist);
    const mp_info = useSelector(state => state.mp_info);

    const [spec_list_search, setSpec_list_search] = useState("");

    const [page, setPage] = useState(1);
    const [paginationSize, setPaginationSize] = useState(10);
    
    const [form_spec_list_search] = Form.useForm();

    const [cookies, setCookie, removeCookie] = useCookies(['token','city_name','city_id','spec_search_specialization']);

    form_spec_list_search.setFieldsValue({ 
        search: spec_list_search, 
        location:locations.location.city_id.toString(), 
        specialization:specialist.search_spec_form.specialization.toString() 
    });

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        if (cookies.spec_search_specialization) {
            dispatch(setSearch_spec_form({
                specialization: cookies.spec_search_specialization
            }));
        }

        let city_id = cookies.city_id ? cookies.city_id : locations.location.city_id;
        let specialization = cookies.spec_search_specialization ? cookies.spec_search_specialization : specialist.search_spec_form.specialization;

        getSpecialistSpecializationList({},dispatch,profile);
        
        await getSpecialistList({
            location: 1321,
            specialization: 'дерматолог'
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getSpecialistList]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });

        //@ Mp_info
        await getMp_info_home({},dispatch)
        .then(async json => {
            console.log ( `%c [API]: [getMp_info_home]`, `color: #A366FF`, json );
            if (json?.code) {
                //Done
            } else {
                let error = [];
                if (json.error[0]) {
                    error.push(json.error[0]);
                }
                if (json.error[1]) {
                    error.push(json.error[1]);
                }
                if (json.error[3]) {
                    error.push((json.error[3]).join(', '));
                }
                message.error(error.join('. '));
            }
        });
    }

    function specialist_spec_list_search_change (e) { 
        setSpec_list_search(e.target.value.replace(/\s+/g,' '));
    }

    var obj = {
        get spec_list () {
            if ( specialist.specialist_list.length > 0 ) {
                let search = spec_list_search.toLowerCase();
                return specialist.specialist_list.filter( function( item ) {
                    return(
                        item['name'].toLowerCase().indexOf( search ) > -1
                    );
                } );
            } else {
                return specialist.specialist_list;
            }
        },
        get locations () {
            var end = locations.locations.map((item, indexedDB) => ({value:item.id,label:item.city}));
            return end;
        },
        get specialization () {
            var end = [{
                value:'',
                label:'Не выбрано'
            }].concat(specialist.specialist_specialization);
            //var end = specialist.spec_search_specialization;
            return end;
        }
    };

    const getOrgTypeTag = (status) => {
        var list = {
            '1': {
                text: 'Бюджетная',
                color: '#52c41a'
            },
            '2': {
                text: 'Частная',
                color: '#faad14'
            },
        };
        if (status !== undefined) {
            return <Tag color={list[status]['color']} >{list[status]['text']}</Tag>
        }
        return <Tag color="#424242" >Неизвестно</Tag>
    }

    function decnum (a,b) { let cases=[2,0,1,1,1,2];return b[(a%100>4 && a%100<20)?2:cases[(a%10<5)?a%10:5]]; }
    
    return (
        <section className='container --search_doctor shadow default_padding marginTop'>
            <section className='top'>
                <section className='container shadow default_padding'>
                    <h1>Найти специалиста</h1>
                </section>
            </section>
            <div className='content'>
                {app_global.loading ?
                    <Skeleton active />
                :
                    <>
                        <div className='left_form'>
                            <Form name="form" className="default_form" form={form_spec_list_search}>
                                <Form.Item key="search" name="search">
                                    <Input disabled={specialist.loading} autoFocus className={`custom_input`} placeholder="Поиск по ФИО" onChange={ specialist_spec_list_search_change } bordered={false} 
                                        prefix={
                                            <SearchOutlined style={{ color: 'rgba(0,0,0,.45)', fontSize: 20 }} />
                                        } 
                                    />
                                </Form.Item>
                            </Form>
                            {
                                mp_info.home[7] ? 
                                    <a className='mp_info' target='_blank' href={mp_info.home[7]['link']}>
                                        <img src={`${API}${mp_info.home[7]['image']}`} />
                                    </a>
                                :
                                    null
                            }
                        </div>
                        <div className='right_content'>
                            {specialist.loading ?
                                    <Skeleton active />
                                :
                                <List itemLayout="vertical"
                                    size="large"
                                    pagination={{
                                        pageSize: 6,
                                        hideOnSinglePage: true,
                                        showSizeChanger: false,
                                        onChange(current, pageSize) {
                                            setPage(current);
                                            setPaginationSize(pageSize)
                                        },
                                    }}
                                    locale={{
                                        emptyText: 
                                            <Empty 
                                                description="Список специалистов пуст"
                                            />
                                    }}
                                    dataSource={obj.spec_list}
                                    renderItem={(item, index) => (
                                        <List.Item key={index} >
                                            <Link to={`/specialist/${item.id}`} exact={ true } onClick={() => scroll.scrollToTop()}>
                                                <div className='left'>
                                                    <div className={`spec_item_left ${item.photo !== null ? 'photo'  : 'no_photo'}`}>
                                                        {item.photo !== null ?
                                                            <img src={`${UPLOADS}/${item.photo}`} />
                                                        :
                                                            <MdOutlineNoPhotography />
                                                        }
                                                    </div>
                                                </div>
                                                <div className='right'>
                                                    <div className="org_name">
                                                        <span className="name">{item.name}</span>
                                                    </div>
                                                    <div className='org_bottom'>
                                                        <p className='last'>{item.specialization}</p>
                                                    </div>
                                                    <div className='org_info'>
                                                        {+item.experience ?
                                                            <p className='experience'>
                                                                <span><b>Стаж: </b>{item.experience} {decnum(item.experience,[ 'год','года','лет' ])} практики</span>
                                                            </p>
                                                        :
                                                            null
                                                        }
                                                        <p className='category'>{item.specializations.map((spec) => <span>{spec.label}</span>)}</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </List.Item>
                                    )}
                                />
                            }
                        </div>
                        <div className='mp_info_mobile'>
                            {
                                mp_info.home[7] ? 
                                    <a className='mp_info' target='_blank' href={mp_info.home[7]['link']}>
                                        <img src={`${API}${mp_info.home[7]['image']}`} />
                                    </a>
                                :
                                    null
                            }
                        </div>
                    </>
                }
            </div>
        </section>
    );
};